/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PriceSearchRequest } from '../models/PriceSearchRequest';
import type { PriceSearchResponse } from '../models/PriceSearchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PriceSearchControllerService {
    /**
     * @param requestBody
     * @returns PriceSearchResponse OK
     * @throws ApiError
     */
    public static search(
        requestBody: PriceSearchRequest,
    ): CancelablePromise<PriceSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static searchCount(
        requestBody: PriceSearchRequest,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/search/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
